import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { Link } from 'react-router-dom';

import OrderItemReviewCard from 'Components/ProductReviews/OrderItemReviews/OrderItemReviewCard';

const AccountReviews = ({ items, reviewsError }) => {
  if (reviewsError) return false;
  const filteredItems = items.filter(item => !item.reviewText);
  if (filteredItems.length < 1) return false;

  return (
    <article className="account-table">
      <h2 className="account-table-heading includes-button">
        <div className="title-container">
          <FormattedMessage id="account-reviews.title" defaultMessage="Review Your Purchases" />
        </div>
        <div className="button-container">
          <Link to="/reviews" className="btn btn-line-account">
            <FormattedMessage id="account-reviews.button.all-reviews" defaultMessage="View all reviews" />
          </Link>
        </div>
      </h2>
      <div className="account-table-row account-reviews-container">
        <div className="fan-grid-container left-align">
          {filteredItems.slice(0, 3).map(item =>
            <OrderItemReviewCard
              key={Math.random()}
              item={item}
              status={get(item, 'order.status')}
              orderID={get(item, 'order._id')}
            />,
          )}
        </div>
      </div>
    </article>
  );
};

AccountReviews.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  reviewsError: PropTypes.bool,
};

AccountReviews.defaultProps = {
  items: [],
  reviewsError: false,
};

export default AccountReviews;
